import { HomeOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, Row, Spin } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Notification from '../../components/notification/notification';
import { login } from '../../services/services';
import './login.css'

const Login: FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    let history = useHistory();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) history.push("/");

    }, [history]);

    const onLogin = async (values: any) => {
        setLoading(true);
        const { username, password } = values;

        try {
            const response = await login(username, password);
            // console.log(response);
            if (response.status === 200) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('name', response.data.nickname);
                localStorage.setItem('memberId', response.data.id);
                localStorage.setItem('role', response.data.rank.name);
                localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
                setLoading(true);
                history.push("/");
            } else {
                setLoading(false);
                Notification('error', 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง')
            }
        } catch (error) {
            setLoading(false);
            Notification('error', 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง')
        }
    };

    return (
        <Spin spinning={loading}>
            <Row justify="center" className="bg">
                <Form
                    form={form}
                    style={{ minWidth: 420 }}
                    className="card"
                    name="signin"
                    onFinish={onLogin}
                >
                    <Card>
                        {/* <div className="header-login">
                            <h4>เข้าสู่ระบบ @Real Lotto</h4>
                            <div className="icon-line">
                                <a href="#" target="_blank">
                                    <HomeOutlined style={{ fontSize: '35px', color: '#6F7DBE' }} />
                                </a>
                            </div>
                        </div> */}
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: 'กรุณาใส่ชื่อผู้ใช้',
                                },
                            ]}
                        >
                            <Input className="real-input" size="large" maxLength={32} prefix={<UserOutlined style={{ color: 'white' }} />} placeholder="ชื่อผู้ใช้" />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'กรุณาใส่รหัสผ่าน',
                                },
                            ]}
                        >
                            <Input className="real-input" size="large" maxLength={32} prefix={<LockOutlined style={{ color: 'white' }} />} type="password" placeholder="รหัสผ่าน" />
                        </Form.Item>

                        <div className="footer">
                            <Button block={true} className="btn" htmlType={'submit'}>
                                เข้าสู่ระบบ
                            </Button>
                        </div>
                    </Card>
                </Form>
            </Row>
        </Spin>
    )
}

export default Login;